'use client';

import { enqueueSnackbar, type SnackbarKey, type SnackbarMessage, type SnackbarOptions } from 'BomdisoftComponents/notifications/snackbars/store';

export const Snackbar = {
  default(msg: SnackbarMessage) {
    this.show(msg, { variant: 'default' });
  },
  error(msg: SnackbarMessage) {
    this.show(msg, { variant: 'error' });
  },
  info(msg: SnackbarMessage) {
    this.show(msg, { variant: 'info' });
  },
  show(message: SnackbarMessage, options?: SnackbarOptions): SnackbarKey {
    return enqueueSnackbar(message, options);
  },
  success(msg: SnackbarMessage) {
    this.show(msg, { variant: 'success' });
  },
  warning(msg: SnackbarMessage) {
    this.show(msg, { variant: 'warning' });
  },
};
